import React, { useState, useEffect } from "react";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../Configuration/API_URL";
import BuySell from "../../Components/ClientDashboard/BuySell";
import ClientProfileCard from "../../Components/ClientDashboard/ClientProfileCard";
import ClientDetails from "./Details/ClientDetails";
import Overview from "./Overview";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
// import { backButton } from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import ReportNew from "./ReportsNew/ReportsNew";
import DetailsKyc from "./Details/Kyc/DetailsKyc";
import DetailsEquity from "./Details/Equity/DetailsEquity";
import { useNavigate } from "react-router-dom";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import MFSection from "./MutualFunds/MFSection";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function ClientDashboard(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [basicDetails, setbasicDetails] = useState();
  const [loader, setLoader] = useState(true);
  const [status, setStatus] = useState(true);
  const navigate = useNavigate();
  if (storeToken == null) {
    window.location.replace("/");
    // localStorage.clear("");
  }

  const getProfileDetail = async () => {
    
    let clientCode = "";
    let clientPan = "";
    let clientStatus = "";
    let tabOnboarding="";
    if(localStorage.getItem("tabOnboarding")){
      tabOnboarding=localStorage.getItem("tabOnboarding")
    }
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
    } 
    if(localStorage.getItem("clientPan")) {
      clientPan = localStorage.getItem("clientPan");
    }
    if (localStorage.getItem("statusOfClient")) {
      clientStatus = localStorage.getItem("statusOfClient");
    }
    let payloadValue = {
      clientCode: clientCode,
      pan: clientPan,
      status: clientStatus,
      type:tabOnboarding
    };
    console.log("payloadvalue",payloadValue)
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetail = await axiosInstance.post(
        DASHBOARD_CLIENT_OVERVIEW.BasicDetails_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetail?.data);
      const response = res?.data;

      if (typeof response == "object") {
        console.log("response basic detail",response)
        setbasicDetails(response);
        localStorage.setItem("panId", response.pan);

        if (response.status == "created") {
          setStatus(false);
        }
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    let clientCode = localStorage.getItem("clientCode");
    let clientPan = localStorage.getItem("clientPan");
    let panId = localStorage.getItem("panId");

    if (
      (clientCode === null || clientCode === undefined) &&
      (clientPan === null || clientPan === undefined) &&
      (panId === null || panId === undefined)
    ) {
      navigate("/dashboard");
      return;
    }

    getProfileDetail();

    return () => {
      localStorage.removeItem("clientCode");
      localStorage.removeItem("panId");
      localStorage.removeItem("clientPan");
      localStorage.removeItem("statusOfClient");
    };
  }, []);

  return (
    <>
      <Header headerDetails={basicDetails} portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />

      <main id="main-content">
        {/* <!-- buy-sell section --> */}
        {/* <BuySell /> */}
        {/* <!-- buy-sell section end --> */}

        {/* <!-- user profile card --> */}
        {/* <button
    onClick={()=>navigate("/Dashboard")}> Back </button> */}
        <ClientProfileCard basicDetails={basicDetails} loader={loader} />
        {/* <!-- user profile card end --> */}

        <div className="content-tabs width-zero">
          {/* <!-- main-nav-tabs --> */}

          <ul className="nav nav-tabs main-nav-tabs" id="myTab" role="tablist">
            {/* <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${status ? "" : "active"}`}
                id="nav-home-tab"
                data-toggle="tab"
                data-target="#overview"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                disabled={status}
              >
                {Constants.Overview}
              </button>
            </li> */}

            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${status ? "" : "active"}`}
                data-toggle="tab"
                id="nav-home-tab"
                data-target="#nav-portfolio"
                type="button"
                role="tab"
                aria-controls="nav-portfolio"
                aria-selected="true"
                disabled={status}
              >
                {Constants.Portfolio}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                // className="nav-link"
                className={`nav-link ${status ? "active" : ""}`}
                id="nav-Kyc"
                data-toggle="tab"
                data-target="#nav-kycTab"
                type="button"
                role="tab"
                aria-controls="nav-Kyc"
                aria-selected="false"
                // disabled={status}
              >
                {Constants.KYC}
              </button>
            </li>

            <li className="nav-item" role="presentation">
              <button
                // className="nav-link"
                className="nav-link"
                id="nav-mf"
                data-toggle="tab"
                data-target="#nav-mfTab"
                type="button"
                role="tab"
                aria-controls="nav-mfTab"
                aria-selected="false"
                disabled={status}
              >
                Mutual Funds
              </button>
            </li>

            <li className="nav-item" role="presentation">
              <button
                // className={`nav-link ${status ? "active" : ""}`}
                className="nav-link"
                id="nav-contact-tab"
                data-toggle="tab"
                data-target="#nav-contact"
                type="button"
                role="tab"
                aria-controls="nav-contact"
                aria-selected="false"
                disabled={status}
              >
                {Constants.Reports}
              </button>
            </li>
          </ul>

          {/* <!-- main content tabs --> */}
          <div className="tab-content child-tabs-content" id="nav-tabContent">
            {/* <div
              className={`tab-pane  fade  ${status ? "" : "show active"}`}
              id="overview"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <Overview />
            </div> */}

            <div
              className={`reports-tab tab-pane  fade equity-tab ${
                status ? "" : "show active"
              } `}
              id="nav-portfolio"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <DetailsEquity />
            </div>

            <div
              // className={`reports-tab tab-pane  fade kyc-tab `}
              className={`kyc-tab tab-pane  fade  ${
                status ? "show active" : ""
              }`}
              id="nav-kycTab"
              role="tabpanel"
              aria-labelledby="nav-Kyc"
            >
              <DetailsKyc kycBasicDetails={basicDetails} loader={loader} />
            </div>

            <div
              className={`mf-tab tab-pane  fade`}
              id="nav-mfTab"
              role="tabpanel"
              aria-labelledby="nav-mf"
            >
              <MFSection />
            </div>

            <div
              className={`reports-tab tab-pane  fade  `}
              // className={`reports-tab tab-pane  fade  ${status ? "show active" : ""}`}
              id="nav-contact"
              role="tabpanel"
              aria-labelledby="nav-contact"
            >
              {/* <ClientReport /> */}
              <ReportNew />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default ClientDashboard;
